import request from '@/utils/request-v2'
import store from '@/store'

const BASE_URL = 'customers/modules'

/**
 * Fetch modules configuration for a data segment.
 * Automatically commits the result to Vuex (setDataSegmentConfigurations)
 * and stores encryptionKey to localStorage if present.
 */
export async function getModules(dataSegmentId, options) {
    var withEncryptionKey = options && options.withEncryptionKey === true
    var params = { dataSegmentId: dataSegmentId }
    if (withEncryptionKey) params.withEncryptionKey = 'true'
    const response = await request({
        url: BASE_URL,
        method: 'get',
        params: params,
    })
    const config = (response && response.data && response.data.data) || (response && response.data) || null
    if (config) {
        store.commit('setDataSegmentConfigurations', config)
    }
    return response
}

/**
 * Update modules configuration for a data segment.
 */
export async function updateModules(id, payload) {
    return request({
        url: `${BASE_URL}/${id}`,
        method: 'put',
        data: payload,
    })
}
